module.exports = __webpack_public_path__ + "img/simulados-de-revisao.f46138b9.png";